import React, { Component } from 'react';

import Dialog from 'material-ui/Dialog';
import { Card } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Config from '../conf';

const Theme = Config.THEME;

class EnterPhone extends Component {

  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: false,
      loading: false
    };

    this.keyTyped = this.keyTyped.bind(this);
    this.nextDisabled = this.nextDisabled.bind(this);
    this.getData = this.getData.bind(this);
    this.handleCloseDialog = this.handleCloseDialog.bind(this);
  }

  parsQuery(value) {
    let result = {};
    const parameters = value.replace('?', '').split('&');
    parameters.forEach((parameter) => {
      const paramName = parameter.substr(0, parameter.indexOf('=')).trim();
      const paramValue = parameter.substr(parameter.indexOf('=') + 1).trim();
      result[paramName] = paramValue;
    });
    return result;
  }

  componentDidMount() {
    const QS = this.parsQuery(this.props.location.search);
    if (QS.paymentId && QS.token && QS.PayerID) {
      this.props.updateField('paypal', {
        paymentId: QS.paymentId,
        token: QS.token,
        PayerID: QS.PayerID
      }, () => {
        this.props.next(2);
      });
      return;
    }
    if (QS.id && !this.props.details.goBackClicked) {
      this.props.updateField('hid', QS.id.trim(), () => {
        this.getData();
      });
    } else if (this.props.match.params['phone'] && !this.props.details.goBackClicked) {
      const phone = this.props.match.params['phone'];
      this.props.updateField('phone', phone, () => {
        this.getData();
      });
    }
  }

  handleCloseDialog() {
    this.setState({
      dialogOpen: false
    });
  }

  nextDisabled() {
    let ret = !this.props.details.phone;
    return ret;
  }

  keyTyped(field, value) {
    this.props.setHasError(field, false);
    this.props.updateField(field, value);
    this.props.updateField('hid', null);
  }

  getData() {
    if (this.state.loading)
      return;
    this.state.loading = true;
    const body = {
      id: this.props.details.hid,
      emailOrPhone: this.props.details.phone ? this.props.details.phone.trim() : null
    };
    fetch(Config.BACKEND_API_URL + 'carpark/check', {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then((response) => {
      return response.json();
    }).then((data) => {
      if (data.status === 200) {
        // if already paid, show dialog popup and terminate
        if (data.details['paid']) {
          this.setState({
            dialogOpen: true
          });
          return;
        }

        const wash = data.details;
        this.props.updateField('id', wash['id']);
        this.props.updateField('name', wash['full_name']);
        this.props.updateField('email', wash['email']);
        this.props.updateField('phone', wash['phone']);
        this.props.updateField('numberPlate', wash['number_plate']);
        this.props.updateField('created', wash['created']);
        const washType = wash['wash_type'];
        const carType = wash['car_type'];
        // update washType field with combined string (of wash type, car type and cost)
        let dollars;
        let costString;
        if (wash['charged']) {
          dollars = wash['charged'];
          costString = '$' + dollars + '.00';
        } else {
          if (washType === 'outie') dollars = 29;
          else if (washType === 'fullo') dollars = 49;
          else if (washType === 'specto') dollars = 69;
          if (carType === 'suv') dollars += 10;
          costString = '$' + dollars + '.00';
        }

        const washDescription = ('washDescription', washType + ' ' + carType + ' ' + costString).toUpperCase();
        this.props.updateField('washDescription', washDescription);
        this.props.next(); // go onto next
      } else {
        throw Error('response status from backend was ' + data.status + ' (data = ' + JSON.stringify(data) + ')');
      }
    }).catch((err) => {
      // set error
      this.props.updateField('phoneError', 'Phone number not found');
      console.log('err:', err);
    }).then(() => {
      this.state.loading = false;
    });
  }

  render() {
    const styles = {
      card: {
        padding: 30,
        paddingTop: 40,
        textAlign: 'center',
        borderRadius: 12
      },
      title: {
        textAlign: 'center',
        margin: 0,
        color: Theme.palette.primary1Color,
        marginBottom: 20
      },
      button: {
        width: 80,
        marginTop: 10
      },
      wrapper: {
        width: '80%',
        maxWidth: 390,
        margin: 'auto',
        marginTop: 10
      },
      field: {
        padding: 0,
        margin: 0,
        marginTop: -15,
        width: '100%'
      },
      inputStyle: {
        width: '100%',
        textAlign: 'center',
        justifyContent: 'center'
      },
      hintStyle: {
        width: '100%',
        color: '#ccc',
        textAlign: 'center',
        justifyContent: 'center'
      },
      paragraph: {
        margin: 10,
        marginBottom: 20
      }
    };

    const actions = [
      <RaisedButton
        label="OK"
        primary={true}
        onTouchTap={this.handleCloseDialog}
      />
    ];

    return (
      <div>
        <Dialog
          title="Thanks, but you've already paid!"
          actions={actions}
          modal={false}
          open={this.state.dialogOpen}
          onRequestClose={this.handleCloseDialog}
        >
          <p>We hope you've enjoyed our service!</p>
          <p>
            When you require another carwash in the future, simply spend 2 minutes to make a booking on our main
            website at <a href="https://www.wipehero.com.au/">www.wipehero.com.au</a> and <strong>we'll come to
            you!</strong>
          </p>
        </Dialog>

        <Card style={styles.card}>
          <h2 style={styles.title}>WipeHero Carparks</h2>

          <div style={styles.paragraph}>
            Please enter your phone number to get started.
          </div>
          <div style={styles.wrapper}>
            <TextField
              style={styles.field}
              hintStyle={styles.hintStyle}
              inputStyle={styles.inputStyle}
              hintText={'Phone Number'}
              floatingLabelText={this.props.details.phone ? 'Phone Number' : ' '}
              floatingLabelFixed={true}
              value={this.props.details.phone}
              onChange={(evt) => this.keyTyped('phone', evt.target.value)}
              errorText={this.props.details.phoneError ? this.props.details.phoneError : ''}
              maxLength={64}
            />
          </div>

          <RaisedButton style={styles.button} disabled={this.nextDisabled()}
            label="Next" primary={true} onClick={this.getData} />
        </Card>
      </div>
    );
  }
}

export default EnterPhone;



// WEBPACK FOOTER //
// ./src/app/payment/EnterPhone.js